module.exports = __webpack_public_path__ + "img/moment_capsule_card_image.6d14261a.jpg";